import React from 'react';
export default function JSONValueNode({ nodeType, styling, labelRenderer, keyPath, valueRenderer, value, valueGetter = (value) => value, }) {
    return (React.createElement("li", { ...styling('value', nodeType, keyPath) },
        React.createElement("label", { ...styling(['label', 'valueLabel'], nodeType, keyPath) }, labelRenderer(keyPath, nodeType, false, false)),
        React.createElement("span", { ...styling('valueText', nodeType, keyPath) }, valueRenderer(valueGetter(value), value, ...keyPath))));
}
